module.exports = __webpack_public_path__ + "img/product_xd_3.08d795b5.jpg";